module.exports = __webpack_public_path__ + "src/fonts/NotoSans-Regular.28ecd53fddfb6c50b3298a838d8aff63.ttf";